// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fuelCredit-page-wrapper {
  cursor: auto;
}
.fuelCredit-page-wrapper .fuelCredit-page .fuelCredit-image-container img {
  height: 30vh;
  max-height: 371px;
  object-fit: cover;
  background: no-repeat;
  border-radius: 0px;
}
.fuelCredit-page-wrapper .fuelCredit-page .fuelCredit-error-container {
  display: flex;
  padding: var(--spacing-extra-big);
  padding-bottom: 0;
  gap: var(--spacing-small);
}
.fuelCredit-page-wrapper .fuelCredit-page .fuelCredit-page-container {
  display: flex;
  padding: var(--spacing-extra-big);
  gap: var(--spacing-small);
}
.fuelCredit-page-wrapper .fuelCredit-page .fuelCredit-page-container .fuelCredit-page-content {
  flex: 3;
  display: flex;
  padding: var(--spacing-regular);
  align-items: flex-start;
  gap: var(--spacing-small);
  flex-shrink: 0;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 20, 0.12);
  border-radius: var(--border-radius-primary);
  flex-direction: column;
  height: 100%;
}
.fuelCredit-page-wrapper .fuelCredit-page .fuelCredit-page-container .fuelCredit-page-content .fuelCredit-page-title {
  display: flex;
  align-items: center;
  gap: var(--spacing-extra-small);
}
.fuelCredit-page-wrapper .fuelCredit-page .fuelCredit-page-container .fuelCredit-page-content .fuelCredit-page-title .ant-typography {
  margin-bottom: 0 !important;
}
.fuelCredit-page-wrapper .fuelCredit-page .fuelCredit-page-container .fuelCredit-page-content .fuelCredit-page-title .vert-icon {
  cursor: auto;
}
.fuelCredit-page-wrapper .fuelCredit-page .fuelCredit-page-container .fuelCredit-page-content .fuelCredit-page-title .vert-icon svg {
  width: 18px;
  height: 18px;
  fill: var(--color-neutral-dark-darker);
}
.fuelCredit-page-wrapper .fuelCredit-page .fuelCredit-page-container .fuelCredit-page-content .operator-avatar-container {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-small);
}
.fuelCredit-page-wrapper .fuelCredit-page .fuelCredit-page-container .fuelCredit-page-content .operator-avatar-container .operator-avatar {
  width: 60px;
  height: 60px;
  border: var(--border-width) solid var(--color-neutral-light);
  border-radius: 100%;
  display: flex;
  justify-content: center;
  cursor: pointer;
  align-items: center;
}
.fuelCredit-page-wrapper .fuelCredit-page .fuelCredit-page-container .fuelCredit-page-content .operator-avatar-container .operator-avatar img {
  width: 70%;
  height: 70%;
  filter: grayscale(1);
  -webkit-filter: grayscale(100%);
}
.fuelCredit-page-wrapper .fuelCredit-page .fuelCredit-page-container .fuelCredit-page-content .operator-avatar-container .operator-avatar.selected {
  border: 1px solid #009dff;
}
.fuelCredit-page-wrapper .fuelCredit-page .fuelCredit-page-container .fuelCredit-page-content .operator-avatar-container .operator-avatar.selected img {
  filter: unset;
  -webkit-filter: unset;
}
.fuelCredit-page-wrapper .fuelCredit-page .fuelCredit-page-container .fuelCredit-page-content .operator-avatar-container .operator-avatar:hover {
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 20, 0.12);
}
.fuelCredit-page-wrapper .fuelCredit-page .fuelCredit-page-container .fuelCredit-page-summary {
  flex: 1;
}
.fuelCredit-page-wrapper .fuelCredit-page .fuelCredit-page-container .divider {
  height: 1px;
  border-top: var(--border-width) solid var(--color-neutral-light-darker);
  width: 100%;
}
@media screen and (max-width: 768px) {
  .fuelCredit-page-wrapper .fuelCredit-image-container {
    padding: var(--spacing-small) !important;
  }
  .fuelCredit-page-wrapper .fuelCredit-image-container img {
    max-height: 120px !important;
    border-radius: 16px !important;
  }
  .fuelCredit-page-wrapper .fuelCredit-page-container {
    display: flex;
    flex-direction: column;
    padding: var(--spacing-small) !important;
  }
  .fuelCredit-page-wrapper .fuelCredit-page-container .fuelCredit-page-content.col {
    flex-basis: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/pages/fuelCredit/FuelCreditStyles.less"],"names":[],"mappings":"AACA;EACE,YAAA;AAAF;AADA;EAMQ,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;AAFR;AARA;EAeM,aAAA;EACA,iCAAA;EACA,iBAAA;EACA,yBAAA;AAJN;AAdA;EAqBM,aAAA;EACA,iCAAA;EACA,yBAAA;AAJN;AAnBA;EAyBQ,OAAA;EACA,aAAA;EACA,+BAAA;EACA,uBAAA;EACA,yBAAA;EACA,cAAA;EACA,gDAAA;EACA,2CAAA;EACA,sBAAA;EACA,YAAA;AAHR;AA/BA;EAqCU,aAAA;EACA,mBAAA;EACA,+BAAA;AAHV;AApCA;EAyCY,2BAAA;AAFZ;AAvCA;EA6CY,YAAA;AAHZ;AA1CA;EA+Cc,WAAA;EACA,YAAA;EACA,sCAAA;AAFd;AA/CA;EAuDU,aAAA;EACA,eAAA;EACA,yBAAA;AALV;AApDA;EA2DY,WAAA;EACA,YAAA;EACA,4DAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;AAJZ;AA9DA;EAoEc,UAAA;EACA,WAAA;EACA,oBAAA;EACA,+BAAA;AAHd;AAKY;EACE,yBAAA;AAHd;AAEY;EAGI,aAAA;EACA,qBAAA;AAFhB;AAKY;EACE,gDAAA;AAHd;AA9EA;EAuFQ,OAAA;AANR;AAjFA;EA0FQ,WAAA;EACA,uEAAA;EACA,WAAA;AANR;AAaA;EACE;IAEI,wCAAA;EAZJ;EAUA;IAIM,4BAAA;IACA,8BAAA;EAXN;EAMA;IASI,aAAA;IACA,sBAAA;IACA,wCAAA;EAZJ;EAeM;IACE,gBAAA;EAbR;AACF","sourcesContent":["// DESKTOP\n.fuelCredit-page-wrapper {\n  cursor: auto;\n\n  .fuelCredit-page {\n    .fuelCredit-image-container {\n      img {\n        height: 30vh;\n        max-height: 371px;\n        object-fit: cover;\n        background: no-repeat;\n        border-radius: 0px;\n      }\n    }\n\n    .fuelCredit-error-container {\n      display: flex;\n      padding: var(--spacing-extra-big);\n      padding-bottom: 0;\n      gap: var(--spacing-small);\n    }\n    .fuelCredit-page-container {\n      display: flex;\n      padding: var(--spacing-extra-big);\n      gap: var(--spacing-small);\n      .fuelCredit-page-content {\n        flex: 3;\n        display: flex;\n        padding: var(--spacing-regular);\n        align-items: flex-start;\n        gap: var(--spacing-small);\n        flex-shrink: 0;\n        box-shadow: 0px 2px 8px 0px rgba(0, 0, 20, 0.12);\n        border-radius: var(--border-radius-primary);\n        flex-direction: column;\n        height: 100%;\n\n        .fuelCredit-page-title {\n          display: flex;\n          align-items: center;\n          gap: var(--spacing-extra-small);\n          .ant-typography {\n            margin-bottom: 0 !important;\n          }\n\n          .vert-icon {\n            cursor: auto;\n            svg {\n              width: 18px;\n              height: 18px;\n              fill: var(--color-neutral-dark-darker);\n            }\n          }\n        }\n\n        .operator-avatar-container {\n          display: flex;\n          flex-wrap: wrap;\n          gap: var(--spacing-small);\n          .operator-avatar {\n            width: 60px;\n            height: 60px;\n            border: var(--border-width) solid var(--color-neutral-light);\n            border-radius: 100%;\n            display: flex;\n            justify-content: center;\n            cursor: pointer;\n            align-items: center;\n            img {\n              width: 70%;\n              height: 70%;\n              filter: grayscale(1);\n              -webkit-filter: grayscale(100%);\n            }\n            &.selected {\n              border: 1px solid #009dff;\n              img {\n                filter: unset;\n                -webkit-filter: unset;\n              }\n            }\n            &:hover {\n              box-shadow: 0px 2px 8px 0px rgba(0, 0, 20, 0.12);\n            }\n          }\n        }\n      }\n      .fuelCredit-page-summary {\n        flex: 1;\n      }\n      .divider {\n        height: 1px;\n        border-top: var(--border-width) solid var(--color-neutral-light-darker);\n        width: 100%;\n      }\n    }\n  }\n}\n\n// MOBILE\n@media screen and (max-width: 768px) {\n  .fuelCredit-page-wrapper {\n    .fuelCredit-image-container {\n      padding: var(--spacing-small) !important;\n      img {\n        max-height: 120px !important;\n        border-radius: 16px !important;\n      }\n    }\n    .fuelCredit-page-container {\n      display: flex;\n      flex-direction: column;\n      padding: var(--spacing-small) !important;\n\n      .fuelCredit-page-content {\n        &.col {\n          flex-basis: auto;\n        }\n      }\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
